// HomeScreenConfigurationLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";

const HomeScreenConfigurationLayout = () => {
  return (
    <div>
      {/* Optional: Page heading or nav here */}
      <Outlet /> {/* This renders nested routes */}
    </div>
  );
};

export default HomeScreenConfigurationLayout;
